import * as Sentry from '@sentry/nextjs';
import { CaptureContext } from '@sentry/types';

import { logger } from '@kamernet/core/Logger';

function unwrapError(wrapped: unknown): object | string {
  try {
    if (!(wrapped instanceof Error)) {
      return String(wrapped);
    }

    const getCause = (cause: unknown): object | string | undefined => {
      if (cause instanceof Error) {
        return {
          ...cause,
          message: cause.message,
          stack: cause.cause == null ? cause.stack : undefined,
          cause: getCause(cause.cause),
        };
      }

      return cause != null ? String(cause) : undefined;
    };

    return {
      ...wrapped,
      message: wrapped.message,
      stack: wrapped.cause == null ? wrapped.stack : undefined,
      cause: getCause(wrapped.cause),
    };
  } catch {
    return 'unable to unwrap the error';
  }
}

export function reportError(error: Error, captureContext?: CaptureContext) {
  const sentryEventId = Sentry.captureException(error, captureContext);

  logger.error({
    message: 'error drained',
    error: unwrapError(error),
    sentryEventId,
    context: captureContext,
  });
}
